import { withJsonFormsMultiEnumProps } from "@jsonforms/react";
import { Dropdown } from "pepsico-ds";
import { useContext, useMemo, useState } from "react";
import { GlobalConfigContext } from "../../../context/GlobalConfigContext";
import { getUpdatedCampaignConfiguration } from "../../campaign/campaignUtils";

const ActivityTypeSelectorComponent = (props) => {
  const { handleChange, label, path, required, uischema, visible, enabled } = props;

  const [selected, setSelected] = useState([]);
  const { campaignsConfiguration, campaignGroups } = useContext(GlobalConfigContext);

  const updatedCampaignConfiguration = getUpdatedCampaignConfiguration(
    campaignsConfiguration,
    campaignGroups
  );

  // Extract all unique activities from all campaigns
  const activityOptions = useMemo(() => {
    const allActivities = [];

    // Iterate through each campaign
    updatedCampaignConfiguration.forEach((campaign) => {
      // Check if campaign has requirement and possibleActivities
      if (campaign.value?.requirement?.possibleActivities?.length) {
        // Extract activities from this campaign
        campaign.value.requirement.possibleActivities.forEach((activity) => {
          // Only add if it's not already in our list (check by slug)
          if (
            !allActivities.some(
              (existingActivity) => existingActivity.id === activity.slug
            )
          ) {
            allActivities.push({
              id: activity.slug,
              displayText: activity.name || activity.slug,
            });
          }
        });
      }
    });

    // Sort activities alphabetically by displayText
    return allActivities.sort((a, b) => a.displayText.localeCompare(b.displayText));
  }, [updatedCampaignConfiguration]);

  const formatData = (data) => (data ? data.map((item) => item.id) : []);

  const handleSelectValue = (val) => {
    setSelected(val);
    handleChange(path, formatData(val));
  };

  // Determine selection mode based on uiSchema options
  const selectionMode =
    uischema?.options?.multiple === false ? "singular" : "multiple";

  return visible ? (
    <div className="multiple-select-wrap">
      <Dropdown
        label={label}
        childList={activityOptions}
        selection={selectionMode}
        isRequired={required}
        disabled={!enabled}
        selectedValue={selected || undefined}
        placeholder={uischema.placeholder || "Select Activity"}
        setSelectedValue={handleSelectValue}
      />
    </div>
  ) : null;
};

export const ActivityTypeSelectorControl = withJsonFormsMultiEnumProps(
  ActivityTypeSelectorComponent
);
